import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {distinctUntilChanged, filter, map, startWith} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {

    constructor(
        private router: Router,
        private titleService: Title
    ) {
    }

    ngOnInit(): void {
        this.router.events.pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            startWith(null), // wichtig: setzt Titel auch beim ersten Render (Prerender)
            map(() => {
                let route = this.router.routerState.root;
                while (route.firstChild) route = route.firstChild;
                return route.snapshot.data?.['title'] ?? 'nahaus.de';
            }),
            distinctUntilChanged()
        ).subscribe(title => this.titleService.setTitle(title));
    }
}
